import { styled } from 'styled-components';

import keyIcon from '~/assets/icons/key.svg';
import walletIcon from '~/assets/icons/wallet.svg';

import { ActionButton } from '../../components/ActionButton';
import { Currency } from '../../components/Currency';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin-bottom: 30px;
`;

const StyledCurrencyDonate = styled(Currency)`
	height: 34px;
	margin-bottom: 10px;

	.label {
		font-size: 30px;
	}
`;

const StyledCurrencyCash = styled(Currency)`
	height: 46px;

	.label {
		font-size: 40px;
		font-weight: 800;
	}

	.icon {
		width: 20px !important;
		height: 20px !important;
		mask-size: 20px !important;
		-webkit-mask-size: 20px !important;
	}
`;

const StyledContainerCurrencyCash = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	margin-bottom: 30px;
`;

const StyledLabelDiscount = styled.div`
	font-family: 'GT Walsheim Pro';
	font-size: 18px;
	color: #fff;
	opacity: 0.5;
	text-decoration: line-through;
`;

const StyledContainerActions = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledButtonTestDrive = styled(ActionButton).attrs({ src: keyIcon })`
	background-color: rgba(0, 0, 0, 0.5);
`;

const StyledButtonBuy = styled(ActionButton).attrs({ src: walletIcon })`
	background-color: #1f8034;
`;

const StyledOnlyCaseContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

const StyledOnlyCaseTopContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr 16px;
	gap: 10px;
	align-items: center;
	margin-top: 20px;
	color: #ffffff;
	font-size: 16px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export {
	StyledButtonBuy,
	StyledButtonContent,
	StyledButtonTestDrive,
	StyledContainer,
	StyledContainerActions,
	StyledContainerCurrencyCash,
	StyledCurrencyCash,
	StyledCurrencyDonate,
	StyledLabelDiscount,
	StyledOnlyCaseContainer,
	StyledOnlyCaseTopContainer,
};
